import React from "react";
import { imgSrc, imgSet } from "@/lib/img";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { useLang } from "@/lib/i18n";
import { resolveMediaUrl } from "@/lib/api";

// Sezione "Scopriamo assieme se questa esperienza è adatta a te" (Home, spedizione, tour leader) con sfondo dal CMS.
export default function ContactCTA({ to = "/contatti", bg, testId = "contact-cta", compact = false }) {
  const { t } = useLang();
  const bgUrl = resolveMediaUrl(bg);
  return (
    <section className={(compact ? "py-24 sm:py-32" : "py-28 sm:py-40") + " border-t border-white/5 relative overflow-hidden"} data-testid={testId}>
      {bgUrl && (
        <>
          <img
            src={imgSrc(bgUrl, 1600)}
            srcSet={imgSet(bgUrl, [800, 1200, 1600])}
            sizes="100vw"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
            decoding="async"
            data-testid={`${testId}-bg`}
          />
          <div className="absolute inset-0 bg-obsidian/75" />
          <div className="absolute inset-0 grain pointer-events-none" />
        </>
      )}
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at 50% 120%, rgba(200,109,59,0.25), transparent 60%)" }} />
      <div className="container-x relative z-10 text-center">
        <Reveal>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream max-w-3xl mx-auto leading-[1.05]" data-testid={`${testId}-title`}>{t("home.cta.title")}</h2>
          <p className="mt-6 max-w-2xl mx-auto text-cream2 leading-relaxed" data-testid={`${testId}-text`}>{t("home.cta.sub")}</p>
          <Link to={to} className="btn-copper mt-10" data-testid={`${testId}-btn`}>
            {t("home.cta.btn")} <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
